import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AboutHero from './components/AboutHero';
import AboutStory from './components/AboutStory';

export default function About() {
  return (
    <div className="min-h-screen relative">
      {/* Page background image - shows through between/behind sections */}
      <div className="fixed inset-0 z-0">
        <img
          src="https://static.wixstatic.com/media/3514c1_b161b134bed143aea02291eb68bb538e~mv2.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10">
        <Navbar />
        <main>
          <AboutHero />
          <AboutStory />
        </main>
        <Footer />
      </div>
    </div>
  );
}